"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = exports.scanAccounts = void 0;
const index_1 = require("@ledgerhq/coin-framework/account/index");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const api_1 = require("./api");
const js_buildSubAccounts_1 = __importDefault(require("./js-buildSubAccounts"));
const js_reconciliation_1 = require("./js-reconciliation");
const logic_1 = require("./logic");
const getAccountShape = (info, syncConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, initialAccount, currency, derivationMode } = info;
    const accountId = (0, index_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
    // Needed for incremental synchronisation
    const startAt = oldOperations.length ? Math.floor(oldOperations[0].date.valueOf() / 1000) : 0;
    const account = yield (0, api_1.getAccount)(address);
    const delegations = yield (0, api_1.getAccountDelegations)(address);
    let subAccounts = [];
    const hasTokens = yield (0, api_1.hasESDTTokens)(address);
    if (hasTokens) {
        const tokenAccounts = yield (0, js_buildSubAccounts_1.default)({
            currency,
            accountId: accountId,
            accountAddress: address,
            existingAccount: initialAccount,
            syncConfig,
        });
        if (tokenAccounts) {
            subAccounts = (0, js_reconciliation_1.reconciliateSubAccounts)(tokenAccounts, initialAccount);
        }
    }
    const delegationBalance = (0, logic_1.computeDelegationBalance)(delegations);
    // Merge new operations with the previously synced ones
    const newOperations = yield (0, api_1.getEGLDOperations)(accountId, address, startAt, subAccounts);
    const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    return {
        id: accountId,
        balance: account.balance.plus(delegationBalance),
        spendableBalance: account.balance,
        operationsCount: operations.length,
        blockHeight: account.blockHeight,
        elrondResources: {
            nonce: account.nonce,
            delegations,
            isGuarded: account.isGuarded,
        },
        subAccounts,
        operations: operations.map(op => {
            const subOperations = (0, index_1.inferSubOperations)(op.hash, subAccounts);
            return Object.assign(Object.assign({}, op), { subOperations });
        }),
    };
});
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape });
//# sourceMappingURL=js-synchronisation.js.map